<amplify-authenticator [hideSignUp]="true">
  <ng-template amplifySlot="header">
    <div style="padding: var(--amplify-space-large); text-align: center">Capture+</div>
  </ng-template>
</amplify-authenticator>
